import React from 'react';
import logo from '../assets/ms.png';
import "../styles/Header.css"; 

const Header = () => {
    return (
        <div className="header-container">
            <img src={logo} alt="Maruti Suzuki" className="logo" />
        </div>
    );
};
export default Header;
